module.exports = __webpack_public_path__ + "img/1.66861ce4.jpg";